// src/app/modules/.../redux/reducers/workflowValidationReducer.js

import {
    GET_WORKFLOW_LEVELS_REQUEST,
    GET_WORKFLOW_LEVELS_SUCCESS,
    GET_WORKFLOW_LEVELS_FAIL,
    SAVE_WORKFLOW_LEVELS_REQUEST,
    SAVE_WORKFLOW_LEVELS_SUCCESS,
    SAVE_WORKFLOW_LEVELS_FAIL,
    SET_WORKFLOW_VALIDATION_LOADING
} from "../actions/workflowValidationActions";

const initialState = {
    levels: {},              // { conge: "both", pret: "admin", ... }
    loading: false,          // utilisé pour disable UI
    error: null,             // message d'erreur
    lastSavedAt: null        // optionnel: pour afficher "dernier enregistrement"
};

export default function workflowValidationReducer(state = initialState, action) {
    switch (action.type) {

        // ✅ loading commun (comme setJobLoading)
        case SET_WORKFLOW_VALIDATION_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        // ===========================
        // ✅ GET LEVELS
        // ===========================
        case GET_WORKFLOW_LEVELS_REQUEST:
            return {
                ...state,
                error: null
            };

        case GET_WORKFLOW_LEVELS_SUCCESS:
            return {
                ...state,
                levels: action.payload || {},
                error: null
            };

        case GET_WORKFLOW_LEVELS_FAIL:
            return {
                ...state,
                error: action.error || "Erreur chargement niveaux"
            };

        // ===========================
        // ✅ SAVE LEVELS
        // ===========================
        case SAVE_WORKFLOW_LEVELS_REQUEST:
            return {
                ...state,
                error: null
            };

        case SAVE_WORKFLOW_LEVELS_SUCCESS:
            return {
                ...state,
                error: null,
                lastSavedAt: new Date().toISOString()
            };

        case SAVE_WORKFLOW_LEVELS_FAIL:
            return {
                ...state,
                error: action.error || "Erreur enregistrement"
            };

        default:
            return state;
    }
}
